import {FC, Fragment} from 'react';
import {isNil} from 'lodash';

type RangeValueProps = {
  min?: number;
  equals?: number;
  max?: number;
  strictMode?: boolean;
};

const RangeValue: FC<RangeValueProps> = ({min, equals, max, strictMode}) => {
  const hasMin = !isNil(min);
  const hasEquals = !isNil(equals);
  const hasMax = !isNil(max);

  if (hasMin && hasMax) {
    return <Fragment key={`${min} - ${max}`}>{min}<strong>{' — '}</strong>{max}</Fragment>;
  } else if (hasMin && !hasMax) {
    return <Fragment key={`> ${min}`}><strong>{strictMode ? '> ' : '≥ '}</strong>{min}</Fragment>;
  } else if (!hasMin && hasMax) {
    return <Fragment key={`< ${max}`}><strong>{strictMode ? '< ' : '≤ '}</strong>{max}</Fragment>;
  } else if (hasEquals) {
    return <Fragment key={`= ${equals}`}><strong>{'= '}</strong>{equals}</Fragment>;
  } else {
    return null;
  }
};

export default RangeValue;
